import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/store';
import { authService } from '../api/auth';
import { setCredentials } from '../features/auth/authSlice';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const location = useLocation();
  const token = authService.getToken();

  useEffect(() => {
    const checkAuth = async () => {
      if (token && !isAuthenticated) {
        try {
          const user = await authService.getCurrentUser();
          dispatch(setCredentials({ token, user }));
        } catch (error) {
          localStorage.removeItem('token');
        }
      }
    };

    checkAuth();
  }, [token, isAuthenticated, dispatch]);

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAuthenticated) {
    return null; // or a loading spinner
  }

  return <>{children}</>;
};

export default PrivateRoute; 